export default __webpack_public_path__ + "static/media/increase_quantity.6754127d.png";